import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ModalNotes from '../modal/modal-notes';
import { closeModal } from '../common/actions/modal-action-creators';
import { domainNotesErrorMessage, domainNotesIsLoadingSelector } from '../common/selectors/domain-notes-selectors';
import { rightPaneTitleSelector } from '../common/selectors/right-pane-selectors';
import { postDomainNote } from '../common/actions/domain-notes-action-creators';

export class DomainDetailsModalNotesContainer extends React.Component{
    saveNote = ( note ) => {
        const { domain, postDomainNote } = this.props;

        postDomainNote( domain, note );
    };

    render(){
        const {
            domain,
            open,
            closeModal,
            errorMessage,
            isLoading
        } = this.props;

        return (
            <ModalNotes
                subtitle={ domain }
                open={ open }
                onClose={ closeModal }
                onSave={ this.saveNote }
                isLoading={ isLoading }
                errorMessage={ errorMessage }
                dataAutomationId="modal-domain-details-add-note"
            />
        );
    }

};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        domain: rightPaneTitleSelector( state ),
        errorMessage: domainNotesErrorMessage( state ),
        isLoading: domainNotesIsLoadingSelector( state ),
    };
};

DomainDetailsModalNotesContainer.propTypes = {
    closeModal: PropTypes.func.isRequired,
    domain: PropTypes.string,
    errorMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    postDomainNote: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { closeModal, postDomainNote } )( DomainDetailsModalNotesContainer );
